import axios from './axios.config'

export const getRedemptionOffer = (slug) => {
  return axios.get(`redemption_offers/${slug}?all=true`)
}
